import { render, staticRenderFns } from "./tile_detail_desc.vue?vue&type=template&id=9bdf62b4&"
import script from "./tile_detail_desc.vue?vue&type=script&lang=js&"
export * from "./tile_detail_desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
